import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Button,
  makeStyles,
} from "@material-ui/core";
import { useDispatch } from "react-redux";

import { reopenItem } from "../../redux/actions";
import { EventNotification } from "../../domain/EventNotification";
import { AppBarButton } from "@ofqual/portal-components/components/SecondaryAppBar";
import { NotInterested } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  dialogActions: {
    padding: 15,
  },
  body: {
    marginTop: 5,
    marginBottom: 5,
  },
}));

export const ReopenButtonAndDialog: React.FC<{
  eventNotification: EventNotification;
}> = ({ eventNotification }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <AppBarButton
        Icon={NotInterested}
        text="Reopen"
        tooltip="Reopen event notification"
        onClick={() => setIsOpen(true)}
        data-test="reopen-notification-button"
      />
      {isOpen && eventNotification && (
        <ReopenDialog
          eventNotification={eventNotification}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

type ReopenDialogProps = {
  eventNotification: EventNotification;
  onClose: () => void;
};

const ReopenDialog: React.FC<ReopenDialogProps> = ({
  onClose,
  eventNotification,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(reopenItem(eventNotification.id));
    onClose();
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-test="reopen-en-dialog"
    >
      <DialogTitle data-test="reopen-en-dialog-title">
        Reopen confirmation
        <Divider />
      </DialogTitle>

      <DialogContent>
        Are you sure you want to reopen the event notification?
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button
          onClick={onClose}
          color="primary"
          data-test="reopen-close-button"
        >
          Close
        </Button>
        <Button
          onClick={handleClose}
          color="primary"
          data-test="confirm-reopen-button"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
